import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function PainPoints() {
  const points = ['Sentís que tu cabeza no se apaga, ni siquiera cuando querés "meditar".', 'Probaste audios, rituales, decretos, limpiezas… y no sostenés nada más de 3 días.', 'Te sentís "mala espiritual" por estar ansiosa, irritable o triste.', 'Sos sensible y absorbés todo (y después te quedás sin energía).', 'Querés calma, pero no querés vivir haciendo cosas raras ni promesas mágicas.'];
  return <Section className="bg-white/40 rounded-3xl my-8" data-id="element-83">
      <h2 className="text-3xl font-serif mb-8 text-center text-warm-brown" data-id="element-84">
        Esto es para vos si…
      </h2>

      <ul className="space-y-6" data-id="element-85">
        {points.map((point, index) => <motion.li key={index} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="flex items-start gap-4" data-id="element-86">
            <span className="flex-shrink-0 mt-1 text-sage" data-id="element-87">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-88">
                <circle cx="12" cy="12" r="10" className="opacity-20" data-id="element-89" />
                <path d="M12 6V18M6 12H18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="hidden" data-id="element-90" />
                <circle cx="12" cy="12" r="4" data-id="element-91" />
              </svg>
            </span>
            <span className="text-lg text-warm-brown/90 leading-relaxed" data-id="element-92">
              {point}
            </span>
          </motion.li>)}
      </ul>
    </Section>;
}